// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastBackwardOutlinedSvg from "@ant-design/icons-svg/es/asn/FastBackwardOutlined";
import AntdIcon from '../components/AntdIcon';

var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardOutlinedSvg
  }));
};

FastBackwardOutlined.displayName = 'FastBackwardOutlined';
export default React.forwardRef(FastBackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FastBackwardOutlined.js
// module id = 1071
// module chunks = 0